/* eslint-disable */
export default {
  copy: '複製',
} as const;

// @key: @#@"copy"@#@ @source: @#@"Copy"@#@
